// Generated from src/img/svg/s2.svg

export const S2 = (props) => {
  return (
    <svg viewBox="0 0 26 13" {...props}>
      <rect fill="#76b72b" height="13" rx="6.5" width="25" x=".5" />
      <g
        aria-label="S2"
        style={{
          fill: "#fff",
          fontFamily: 'HelveticaNeue-Bold,"Helvetica Neue"',
          fontSize: "10px",
          fontWeight: "700",
        }}
      >
        <path d="M7.24 7.65h1.52q0 .67.48 1.02.41.3 1.1.3.54 0 .9-.17.49-.23.49-.72 0-.61-1.1-.92-1.9-.54-2.05-.62-1.1-.53-1.1-1.67 0-1.03.85-1.63.76-.53 1.82-.53 1.23 0 1.99.53.87.61.87 1.77h-1.52q-.06-1.08-1.41-1.08-.43 0-.73.18-.35.22-.35.63 0 .39.39.57.3.14 1.74.51.84.21 1.25.48.87.56.87 1.6 0 1.02-.76 1.64-.8.65-2.21.65-1.29 0-2.12-.61-.93-.69-.92-1.93M15.22 5.71h-1.36q-.04-1.24.63-2.03.68-.8 1.91-.8 1 0 1.68.58.72.62.72 1.61 0 .93-.62 1.59-.31.33-1.36 1.01-.92.61-1.29 1.13h3.31v1.22H13.7q.01-1.09.65-1.87.41-.48 1.56-1.26.82-.56.97-.69.5-.46.5-1.02 0-.49-.3-.78-.29-.3-.75-.3-.58 0-.87.53-.24.43-.24 1.08" />
      </g>
    </svg>
  );
};
